import { memo, useCallback, useMemo, useRef } from 'react';
import equal from 'fast-deep-equal';
import { cn } from '@divlab/divanui';

import * as PageProductStore from '@Stores/PageProduct';
import * as Cart from '@Queries/Cart';
import { useDeps } from '@Contexts/DI';
import useTranslation from '@Queries/useTranslation';
import Link from '@UI/Link';
import styles from './BuyLink.module.css';

import type { LinkProps } from '@UI/Link';
import type { FC } from 'react';

export interface BuyLinkProps extends LinkProps {
  className?: string;
}

const BuyLink: FC<BuyLinkProps> = (props) => {
  const { className, ...restProps } = props;
  const page = PageProductStore.useData();
  const parameterValues = PageProductStore.getParameterValues();
  const { t } = useTranslation();
  const defaultParameterValues = useRef(parameterValues);
  const { logger } = useDeps();
  const addToCart = Cart.useAddToCart();

  const isModifiedParameters = useMemo(() => {
    return !equal(defaultParameterValues.current, parameterValues);
  }, [parameterValues, defaultParameterValues]);

  const handleError = useCallback(
    (err: unknown) => {
      logger.log(err);
    },
    [logger],
  );

  const handleClick = useCallback(() => {
    if (addToCart.isPending || addToCart.isError) {
      return;
    }

    addToCart.mutate(
      {
        products: [
          {
            isModular: page.isModular,
            shopProductId: page.product.id,
            parameterValues,
            isModifiedParameters,
          },
        ],
        options: { isRelated: false },
        analyticsData: {
          products: [page.product],
          label: 'Карточка товара',
        },
      },
      {
        onError: handleError,
      },
    );

    // ModalWindows.open('Cart', {
    //   products: [
    //     {
    //       isModular: page.isModular,
    //       shopProductId: page.product.id,
    //       parameterValues,
    //       isModifiedParameters,
    //     },
    //   ],
    //   analyticsLabel: 'Карточка товара',
    // });
  }, [addToCart, page.isModular, page.product, parameterValues, isModifiedParameters, handleError]);

  return (
    <Link
      {...restProps}
      className={cn(styles.link, className)}
      data-testid='sidebar-buy-button'
      view='secondary'
      underlined
      onClick={handleClick}
    >
      {t('ui.add-to-cart')}
    </Link>
  );
};

export default memo(BuyLink);
